import { IPopoverProps, PopoverPosition } from '@mc/react-core';

export const MAX_FUTURE_DATE = new Date('2600-1-1');
export const MIN_FUTURE_DATE = new Date('1753-1-1');
export const DATE_INPUT_POPOVER_PROPS: Partial<IPopoverProps> = {
  modifiers: {
    preventOverflow: {
      enabled: false,
      boundariesElement: 'scrollParent',
    },
    flip: { enabled: true },
  },
  position: PopoverPosition.BOTTOM,
  minimal: true,
  fill: true,
};
